import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedNumber } from 'react-intl';
import { darken, lighten, rgba } from 'polished';
import { updateTransactionItemQuantityAction, removeTransactionItemAction } from '../../../actions';

const ItemListWrapper = styled.div`
  flex: 1;
  color: #aaaaaa;
  padding: 15px;
  overflow-y: auto;

  table {
    border-collapse: collapse;
  }

  td {
    padding: 5px;
  }

  tr:nth-child(even) {
    background: #fff;
    color: #888;
  }

  tr:nth-child(odd) {
    //background: #ffba62;
    background: #eee;
    color: #888;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonLeft = styled.div`
  width: 20px;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 2px 0px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, props.color), 0.4)};
`;

const Quantity = styled.div`
  padding: 0px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonRight = styled.div`
  width: 20px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 2px 0px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, props.color), 0.4)};
`;

const ItemList = ({ transactionId }) => {
  const lines = useSelector((state) => state?.receipt?.lines);
  const dispatch = useDispatch();

  const changeQuantity = (line, direction) => {
    if (direction === '+') {
      dispatch(updateTransactionItemQuantityAction(transactionId, line.ID, parseInt(line.quantity) + 1));
    } else {
      if (line.quantity > 1) {
        dispatch(updateTransactionItemQuantityAction(transactionId, line.ID, parseInt(line.quantity) - 1));
      } else {
        dispatch(removeTransactionItemAction(transactionId, line.ID));
      }
    }
  };

  return (
    <ItemListWrapper>
      <table width={'100%'}>
        <colgroup>
          <col span={1} style={{ width: '50%' }} />
          <col span={1} style={{ width: '25%' }} />
          <col span={1} style={{ width: '25%' }} />
        </colgroup>
        <tbody>
        {lines?.data?.map((line, index) => {
          return (
            <tr key={index}>
              <td>{line.data.name}</td>
              <td>
                <ButtonGroup>
                  <ButtonLeft
                    color={'#fb8c00'}
                    onClick={() => {
                      changeQuantity(line.data, '-');
                    }}>
                    <span>-</span>
                  </ButtonLeft>
                  <Quantity>{parseInt(line.data.quantity)}</Quantity>
                  <ButtonRight
                    color={'#fb8c00'}
                    onClick={() => {
                      changeQuantity(line.data, '+');
                    }}>
                    +
                  </ButtonRight>
                </ButtonGroup>
              </td>
              <td style={{ textAlign: 'right' }}>
                <FormattedNumber value={parseFloat(line.data.amount)} minimumFractionDigits={2} />
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </ItemListWrapper>
  );
};

export default ItemList;
